import { render, staticRenderFns } from "./QuestionPaging.vue?vue&type=template&id=15a7152b&scoped=true&"
import script from "./QuestionPaging.vue?vue&type=script&lang=js&"
export * from "./QuestionPaging.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPaging.vue?vue&type=style&index=0&id=15a7152b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a7152b",
  null
  
)

export default component.exports